// @flow

import type { ThreeDSecure } from '@tectonics/prs/merchant';

export function getPaymentMethod(threedsecure: ThreeDSecure, country: string, selectedPaymentMethod: string): string | null {
  const allowedCards = threedsecure.allowed_cards_by_country;
  if (!allowedCards) {
    return null;
  }

  const foundCountryNode = allowedCards.find(allowedCard => allowedCard[country]);
  if (!foundCountryNode) {
    return null;
  }

  const foundPaymentMethodNode = foundCountryNode[country].find(paymentMethod => paymentMethod[selectedPaymentMethod]);
  if (!foundPaymentMethodNode) {
    return null;
  }

  return selectedPaymentMethod;
}
